'use client';

import ErrorTemplate from '@templates/ErrorTemplate/ErrorTemplate';

export default function Error({ error, reset }) {
  return <ErrorTemplate error={error} reset={reset} />;
}
